// @ts-nocheck
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';
import { getTheme } from 'settings/theme';

const { palette } = getTheme();
const TextareaInputWrapper: StatelessFunctionalComponent<any> = styled.div`
  textarea {
    border: 0.1rem solid ${palette.greyscale.pewter};
    border-radius: 0.4rem;
    line-height: 2.4rem;
    padding: 0.8rem 1.2rem;
    width: 100%;

    :hover {
      padding: 0.7rem 1.1rem;
    }
  }
`;
export default TextareaInputWrapper;
